module.exports = __webpack_public_path__ + "static/media/replayBtn.7250867a.svg";